import { z } from "zod";

const TaskAttemptTypeValues = ["ATTEMPT", "REQUEST"] as const;
const TaskAttemptTypeSchema = z.enum(TaskAttemptTypeValues);
export const TaskAttemptType = TaskAttemptTypeSchema.enum;
